import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";
import Access from "constants/Access";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Users',
		url: '/users',
		icon: 'users',
	},
];

class User extends Framework.Components.View {

	render() {
		let { locations, states, reloadShell, userAccess } = this.props.rootState;
		let breadcrumbs = [
			{
				name: 'Dashboard',
				url: '/',
				icon: 'dashboard',
			},
			{
				name: 'Users',
				url: userAccess <= Access.Supervisor ? '/users' : `/users/${this.props.id}`,
				icon: 'users',
			},
			{
				name: this.state.name,
				url: `/users/${this.props.id}`,
				icon: 'clock-o',
			}
		]

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>

				<Objects.User
					id={this.props.match.params.id}
					history={this.props.history}
					locations={locations}
					states={states}
					reloadShell={reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					updateName={this.updateName}
					baseUrl={this.props.baseUrl}
				/>
			</div>
		)
	}
};

export default Framework.Components.withRootState(User);